/**
 * For Next JS 14.x
 * In Next JS 14.x type script file wont be imported inside a JS file.
 * cors-header.js needs the JS version of CSP setting retrieval using GraphQL
 */

const { gql } = require('graphql-tag');
const {
  createGraphQLJavaScriptClientFactory,
} = require('../graphql-client-factory/graphql-javascript-client-factory');
const config = require('../../temp/config');

// CSP Query in JS (copied from your TS file)
const CspSettingsQuery = gql`
  query CspSettings {
    item(path: "{233A47A5-EBAD-4DD6-813D-DD2EB20983A2}", language: "en") {
      id
      name
      ... on ContentSecurityPolicySettings {
        scriptSrc {
          value
        }
        scriptSrcElem {
          value
        }
        styleSrc {
          value
        }
        imgSrc {
          value
        }
        connectSrc {
          value
        }
        frameSrc {
          value
        }
        mediaSrc {
          value
        }
        frameAncestors {
          value
        }
      }
    }
  }
`;

// Get CSP Directives and retrieve domain settings from Sitecore
async function getCSPDirectives() {
  const isDev = process.env.NODE_ENV === 'development';
  const cspSettings = await getCSPSettings();

  // Sanitize CSP values to remove invalid characters like \r\n
  const sanitizeCSPValue = (value) => {
    if (!value) return '';
    return value
      .replace(/[\r\n\t]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const cspDirectives = [
    "default-src 'self'",
    `script-src 'self' ${isDev ? "'unsafe-eval'" : ''} ${sanitizeCSPValue(cspSettings.scriptSource)}`,
    `script-src-elem 'self' 'unsafe-inline' ${sanitizeCSPValue(cspSettings.scriptElement)}`,
    `style-src 'self' 'unsafe-inline' ${sanitizeCSPValue(cspSettings.styleSource)}`,
    `img-src 'self' data: https: ${sanitizeCSPValue(cspSettings.imageSource)}`,
    `font-src 'self' data: https:`,
    `connect-src 'self' ${config.sitecoreApiHost} ${sanitizeCSPValue(cspSettings.connectSource)}`,
    `frame-src 'self' ${config.sitecoreApiHost.replace(/\/$/, '')} ${sanitizeCSPValue(cspSettings.frameSource)}`,
    `frame-ancestors 'self' ${config.sitecoreApiHost} ${sanitizeCSPValue(cspSettings.frameAncestors)}`,
    `media-src 'self' https: data: ${sanitizeCSPValue(cspSettings.mediaSource)}`,
    "object-src 'none'",
    "base-uri 'self'",
    "form-action 'self'",
    "worker-src 'self' blob:",
    "manifest-src 'self'",
    'report-to csp-endpoint',
    `report-uri ${config.publicUrl}/api/csp-report/xt2c9f8er8`,
  ].join('; ');

  return cspDirectives;
}

// Retrieve CSP settings via GraphQL
async function getCSPSettings() {
  try {
    const graphqlClientFactory = createGraphQLJavaScriptClientFactory(config);
    const graphqlClient = graphqlClientFactory();

    const result = await graphqlClient.request(CspSettingsQuery);

    return {
      scriptSource: result.item?.scriptSrc?.value || '',
      scriptElement: result.item?.scriptSrcElem?.value || '',
      styleSource: result.item?.styleSrc?.value || '',
      imageSource: result.item?.imgSrc?.value || '',
      connectSource: result.item?.connectSrc?.value || '',
      frameSource: result.item?.frameSrc?.value || '',
      frameAncestors: result.item?.frameAncestors?.value || '',
      mediaSource: result.item?.mediaSrc?.value || '',
    };
  } catch (error) {
    console.error('Failed to fetch CSP settings from Sitecore:', error);
    // Return empty settings as fallback
    return {
      scriptSource: '',
      scriptElement: '',
      styleSource: '',
      imageSource: '',
      connectSource: '',
      frameSource: '',
      frameAncestors: '',
      mediaSource: '',
    };
  }
}

module.exports = {
  getCSPDirectives,
};
